import type {
  BenchSortType,
  ConversionCreditCampaign,
  SortingOption,
} from '__generated__/globalTypes';

import { session } from '.';

export enum IOsMobileAppVersion {
  IOS_1 = 'ios-1',
  IOS_GOLD = 'ios-gold',
}
export type MobileAppVersion = '1' | '2' | '3' | '4' | IOsMobileAppVersion;
export const SessionKeys = {
  forcedEnv: 'forcedEnv',
  forcedFlag: 'forcedFlag',
  forcedFlags: 'forcedFlags',
  sport: 'sport',
  signupPromo: 'signup-promo',
  mobileApp: 'mobileApp',
  deeplink: 'deeplink',
  appBuildVersionNumber: 'appBuildVersionNumber',
  googlePlayStoreCountryCode: 'googlePlayStoreCountryCode',
  sawPaidCardExplanatoryDialog: 'sawPaidCardExplanatoryDialog',
  debugI18n: 'debugI18n',
  dismissedLineupPredictionTimerGWs: 'dismissedLineupPredictionTimerGWs',
  composeTeamSelection: 'composeTeamSelection',
  expandedGroupSlugPerFixture: 'expandedGroupSlugPerFixture',
  composeFilters: 'composeFilters',
  storefrontCountryCode: 'storefrontCountryCode',
  bestPackCardPictureUrl: 'bestPackCardPictureUrl',
} as const;

type Environment = 'staging' | 'development' | 'production' | 'mockprod';
export type SessionStorageEntries = {
  [SessionKeys.forcedEnv]: Environment;
  [SessionKeys.forcedFlag]: Record<string | symbol, string>;
  [SessionKeys.forcedFlags]: Environment;
  [SessionKeys.sport]: string;
  [SessionKeys.signupPromo]: Pick<ConversionCreditCampaign, 'campaignCode'> & {
    endDate: string;
  };
  [SessionKeys.mobileApp]: MobileAppVersion;
  [SessionKeys.deeplink]: string;
  [SessionKeys.appBuildVersionNumber]: number;
  [SessionKeys.googlePlayStoreCountryCode]: string;
  [SessionKeys.sawPaidCardExplanatoryDialog]: string;
  [SessionKeys.debugI18n]: 'true' | 'false';
  [SessionKeys.dismissedLineupPredictionTimerGWs]: string[];
  [SessionKeys.composeTeamSelection]: {
    so5LeaderboardSlug: string;
    composeSessionId: string;
    benchObjectIds: Nullable<string>[];
  };
  [SessionKeys.expandedGroupSlugPerFixture]: Record<string, string[]>;
  [SessionKeys.composeFilters]: {
    includeUsed?: boolean;
    includeNoGame?: boolean;
    startersOnly?: boolean;
    confirmedStartersOnly?: boolean;
    sortType?: { type: BenchSortType; direction: SortingOption };
  };
  [SessionKeys.storefrontCountryCode]: string;
  [SessionKeys.bestPackCardPictureUrl]: string;
};

export const sessionStorage = {
  getItem: <K extends keyof SessionStorageEntries>(value: K) =>
    session.getItem(value) as SessionStorageEntries[K] | null,
  setItem: <K extends keyof SessionStorageEntries>(
    key: K,
    value: SessionStorageEntries[K] | null
  ) => session.setItem(key, value),
  removeItem: <K extends keyof SessionStorageEntries>(key: K) =>
    session.removeItem(key),
  key: (index: number) => session.key(index),
  length: session.length,
  clear: session.clear,
};
